import { doExport, handleResult, post, postStream } from '@/util';
import { Message } from '../chat/components/ChatContainer';
import { Result, TableQuery } from '@/typings';

export const doChat = (message: any, onProgress?: (val: string, conversation: Message['conversation']) => void) => {
	return new Promise<{ result: string; conversation: Message['conversation'] }>(resolve => {
		const onSuccess = (result: string, conversation: Message['conversation']) => {
			resolve({ result, conversation });
		};
		postStream('/rest/chat/chatMsg', message, onProgress, onSuccess);
	});
};

export const knowledgeList = (params: { user: string; datasetId: string; pageNo: number; pageSize: number }) => {
	return new Promise<TableQuery<any>>((resolve, reject) => {
		post(
			`/dataset/document/page`,
			params,
			(result: Result<TableQuery<any>>) =>
				handleResult(
					result,
					({ data }) => {
						resolve(data);
					},
					msg => {
						reject(msg);
					},
				),
			reject,
			true,
		);
	});
};

export const getUplaodFile = (params: { path: string }) => {
	return new Promise<any>((resolve, reject) => {
		doExport(`/app/dataset/document/preview`, params, blob => resolve(blob), reject);
	});
};

/** 创建空知识库 */
export const createKnowledge = (params: { user: string; name: string; description?: string }) => {
	return new Promise<any>((resolve, reject) => {
		post(
			`/rest/knowledge/create/datasets`,
			{ ...params, indexing_technique: 'economy', permission: 'only_me' },
			result =>
				handleResult(
					result,
					({ user }) => {
						resolve(user);
					},
					msg => {
						reject(msg);
					},
				),
			reject,
		);
	});
};

/** 删除文档 */
export const delDocument = (params: { dataset_id: string; document_id: string }) => {
	return new Promise<string[]>((resolve, reject) => {
		post(
			`/rest/knowledge/document/del`,
			params,
			result =>
				handleResult(
					result,
					({ data }) => {
						resolve(data);
					},
					msg => {
						reject(msg);
					},
				),
			reject,
		);
	});
};
